<template>
  <no-auth-layout @back="back" :currentStep="currentStep + 1" :enable-scroll-event="true">
    <div
      class="flex flex-col items-start w-full h-full gap-2 px-[24px] md:px-0 md:max-w-[552px] md:mx-auto"
    >
      <!-- Registration first part goes here -->
      <RegisterMemberStatus
        v-if="currentStep == 0"
        :registrationPageData="registrationPageData"
        @next="nextStep"
        class="w-full"
      ></RegisterMemberStatus>
      <!-- Registration second part goes here -->
      <AboutYourself
        v-if="currentStep == 1"
        :registrationPageData="registrationPageData"
        :cgData="cgData"
        @next="nextStep"
      ></AboutYourself>
      <!-- Registration third part goes here -->
      <MobileOtp
        v-if="currentStep == 2"
        :registrationPageData="registrationPageData"
        :isOtpType="'emailOtp'"
        :email="registrationPageData.aboutyourself.email"
        @next="nextStep"
      ></MobileOtp>
      <!-- Registration fourth part goes here -->
      <NewPasswordForm v-if="currentStep == 3" @next="nextStep"></NewPasswordForm>
      <!-- Password Created Complete -->
      <PasswordCreated v-if="currentStep == 4" />
    </div>
  </no-auth-layout>
</template>

<script>
import NoAuthLayout from '@/components/NoAuth.vue';
import AboutYourself from '@/components/RegisterPage/AboutYourself.vue';
import MobileOtp from '@/components/RegisterPage/MobileOtp.vue';
import NewPasswordForm from '@/components/RegisterPage/NewPasswordForm.vue';
import PasswordCreated from '@/components/RegisterPage/PasswordCreated.vue';
import RegisterMemberStatus from '@/components/RegisterPage/RegisterMemberStatus.vue';
import { TOTAL_STEPS } from '@/constants/register/stageConfig';
import navigationService from '@/utils/navigation-service';
import { mapState } from 'vuex';
import {
  trackRegistrationCompleted,
  trackRegistrationStarted,
  trackRegistrationStepViewed,
} from '@/utils/analytics';

const PUBLIC_REGISTRATION_STEPS = [
  'member-status',
  'about-yourself',
  'email-otp',
  'new-password',
  'password-created',
];

export default {
  components: {
    AboutYourself,
    MobileOtp,
    RegisterMemberStatus,
    NoAuthLayout,
    NewPasswordForm,
    PasswordCreated,
  },
  computed: {
    ...mapState('registration', ['registrationPageData', 'cgData', 'currentStep', 'loading']),
  },
  data() {
    return {
      hasTrackedRegistrationStart: false,
      hasTrackedRegistrationCompletion: false,
    };
  },
  watch: {
    currentStep(newStep, oldStep) {
      if (newStep === oldStep) return;
      this.trackCurrentRegistrationStep();
    },
  },
  async ionViewWillEnter() {
    await this.$store.dispatch('registration/fetchCgData');
    this.trackCurrentRegistrationStep();

    // Register custom back handler for swipe navigation
    navigationService.registerBackHandler(() => {
      this.back();
    }, this.$route.path);

    // Register custom forward handler for swipe navigation
    navigationService.registerForwardHandler(() => {
      this.handleForward();
    }, this.$route.path);
  },

  ionViewWillLeave() {
    // Clear custom handlers when leaving the page
    navigationService.clearBackHandler();
    navigationService.clearForwardHandler();
  },
  methods: {
    trackCurrentRegistrationStep() {
      if (!this.hasTrackedRegistrationStart) {
        trackRegistrationStarted({
          flow: 'public',
          source: 'registration-page',
        });
        this.hasTrackedRegistrationStart = true;
      }

      trackRegistrationStepViewed({
        flow: 'public',
        step: this.currentStep,
        stepName: PUBLIC_REGISTRATION_STEPS[this.currentStep],
        stepNumber: this.currentStep + 1,
        stepTotal: TOTAL_STEPS + 1,
        source: 'registration-page',
      });

      if (this.currentStep >= TOTAL_STEPS && !this.hasTrackedRegistrationCompletion) {
        trackRegistrationCompleted({
          flow: 'public',
          source: 'registration-page',
        });
        this.hasTrackedRegistrationCompletion = true;
      }
    },
    nextStep(data) {
      if (data) {
        // Normalize cgId to uppercase and remove spaces before storing
        const normalizedData = { ...data };
        if (normalizedData.cgId) {
          normalizedData.cgId = normalizedData.cgId.toUpperCase().replace(/\s+/g, '');
        }
        this.$store.dispatch('registration/updateAboutYourself', normalizedData);
      }
      this.$store.dispatch('registration/updateStep', this.currentStep + 1);
    },
    back() {
      // Custom logic when back button is clicked
      if (this.currentStep === 0) {
        this.$router.push('/pre-sign-in');
      } else {
        this.$store.dispatch('registration/updateStep', this.currentStep - 1);
      }
    },
    handleForward() {
      // Handle forward navigation for registration flow
      if (this.currentStep < TOTAL_STEPS) {
        // Move to next step
        this.$store.dispatch('registration/updateStep', this.currentStep + 1);
      } else {
        // At last step, no forward navigation available
        console.log('Registration: No forward navigation available (at last step)');

        // Provide haptic feedback
        if (window.navigator && window.navigator.vibrate) {
          window.navigator.vibrate(50);
        }
      }
    },
  },
};
</script>
